import { lazy } from 'react';

export default {
    Login: lazy(() => import('./Login')),
    Registration: lazy(() => import('./Registration')),
    Recover: lazy(() => import('./Recover')),
    PayinWork: lazy(() => import('./payin/Work')),
    PayinHistory: lazy(() => import('./payin/History')),
    PayinOrder: lazy(() => import('./payin/Order')),
    PayoutWork: lazy(() => import('./payout/Work')),
    PayoutHistory: lazy(() => import('./payout/History')),
    PayoutOrder: lazy(() => import('./payout/Order')),
    Settings: lazy(() => import('./Settings')),
    PrivacyPolicy: lazy(() => import('./PrivacyPolicy')),
    NotFound: lazy(() => import('./NotFound')),
};
